import { Checkbox as MCheckbox } from '@mantine/core';
import classes from './checkbox.module.scss';

export const Checkbox = MCheckbox.extend({
  classNames: classes,
});
